var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader-container"},[_c('i',{staticClass:"fal fa-spinner fa-3x fa-spin"})])
}]

export { render, staticRenderFns }